import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ComponentsComponent } from './components/components.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { PagesComponent } from './pages/pages/pages.component';

const routes: Routes = [
  { path: 'screens/pages', component: PagesComponent, data: { title: $localize`Pages` } },
  { path: 'screens/components', component: ComponentsComponent, data: { title: $localize`UI Components` } },
  { path: 'screens/landing-page', component: LandingPageComponent, data: { title: $localize`Landing Page` } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ScreensRoutingModule {}
